const register = {
  path: 'register',
  component: resolve => require(['../../../pages/register'], resolve)
}

export default register
